import { render } from "./SellDetailSearchPopup.vue?vue&type=template&id=06bbd87a"
import script from "./SellDetailSearchPopup.vue?vue&type=script&lang=js"
export * from "./SellDetailSearchPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__